import React from 'react';
import { cn } from '../../utils/cn';

const VARIANTS = {
  neutral:  'bg-bg-2 text-text border-border',
  ink:      'bg-ink text-cream border-ink',
  cream:    'bg-cream text-ink border-cream-4',
  success:  'bg-success-bg text-success border-success/20',
  warn:     'bg-warn-bg text-warn border-warn/20',
  danger:   'bg-danger-bg text-danger border-danger/20',
  info:     'bg-info-bg text-info border-info/20',
};

const SIZES = {
  sm: 'h-5  px-1.5 text-[10.5px] gap-1',
  md: 'h-6  px-2   text-[11.5px] gap-1.5',
  lg: 'h-7  px-2.5 text-xs       gap-1.5',
};

export function Badge({ variant = 'neutral', size = 'md', dot, leadingIcon, className, children, ...rest }) {
  return (
    <span
      className={cn(
        'inline-flex items-center font-semibold rounded-full border whitespace-nowrap',
        SIZES[size],
        VARIANTS[variant],
        className
      )}
      {...rest}
    >
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', dotColorFor(variant))} aria-hidden />}
      {leadingIcon}
      {children}
    </span>
  );
}

function dotColorFor(v) {
  return {
    neutral: 'bg-mute',
    ink:     'bg-cream',
    cream:   'bg-ink',
    success: 'bg-success',
    warn:    'bg-warn',
    danger:  'bg-danger',
    info:    'bg-info',
  }[v];
}

export default Badge;
